import React, { useState } from 'react';

import { Menu, MenuList, ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useI18n } from '@hydra/common/customHooks';
import { Icon, MenuItem } from '@hydra/common/components';

import settings from '@hydra/utils/settings';

const useStyles = makeStyles(theme => ({
  languages: {
    fontSize: theme.typography.fontSizeBase
  },
  language: {
    fontSize: theme.typography.fontSizeSmall,
    fontWeight: theme.typography.fontWeightSemibold
  }
}));

export function LanguageSwitcher () {
  const classes = useStyles();
  const { locale, languageLabels, location } = useI18n();
  const { languages } = settings.get('translations');

  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick (event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose () {
    setAnchorEl(null);
  }

  const languageMenuItems = languages
    .filter(language => language !== locale)
    .map((language, index) => {
      const newLocation = location.replace(/^\/\S\S\//, `/${language}/`);
      return (
        <MenuItem key={index} onClick={handleClose} component={ButtonBase} href={newLocation}>
          <Typography noWrap component='div'>
            <div className={classes.languages}>
              {languageLabels[language]}
            </div>
          </Typography>
        </MenuItem>
      );
    });

  const type = anchorEl ? 'chevron-up' : 'chevron-down';

  return (
    <div id='nav-languages'>
      <ButtonBase onClick={handleClick}>
        <Typography noWrap component='div'>
          <div className={classes.language}>
            {languageLabels[locale]}
          </div>
        </Typography>
        <Icon size='md' color='grey' type={type} />
      </ButtonBase>
      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuList disablePadding>
          {languageMenuItems}
        </MenuList>
      </Menu>
    </div>
  );
}

export default LanguageSwitcher;
